<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <v-col>
            <h2 class="pb-5">
              {{ this.pageTitle }}
              <span class="page_title_value">{{ this.pageTitleValue }}</span>
            </h2>
          </v-col>
        </v-row>
        <v-row><v-col cols="4" sm="10" class="pb-5 mt-n10 ml-n3"><v-subheader class="blue--text">{{$t('clockdata.defaultsettings')}}</v-subheader></v-col></v-row>
        <v-row>
          <v-col cols="10" class="pb-n5 mt-n8">
            <v-autocomplete
              outlined
              :label="this.$t('processclockdatarecord.selectimportfileformat')"
              type="text"
              :rules="[rules.required]"
              v-model="formData.logicid"
              dense
              :items="logiclist"
              @change="ChangeLogic(formData.logicid)"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('clockdata.inindicator')"
              type="text"
              v-model="formData.inindicator"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('clockdata.outindicator')"
              type="text"
              v-model="formData.outindicator"
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row><v-col cols="4" sm="10" class="pb-5 mt-n8 ml-n3"><v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader></v-col></v-row>
        <v-row>
          <v-col cols="4" sm="10" class="pb-n5 mt-n8">
            <v-file-input
              :label="this.$t('processclockdatarecord.file')"
              ref="importfile"
              v-model="formData.importfile"
              outlined
              dense
              show-size
              prepend-icon=""
              accept=".txt, .xlsx"
              style="font-size: 14px"
              :rules="[rules.required]"
            >
            </v-file-input>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5" sm="5" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.fromdate')"
              type="date"
              ref="startdate"
              :rules="[rules.required]"
              v-model="formData.startdate"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="5" sm="5" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.todate')"
              type="date"
              ref="enddate"
              :rules="[rules.required]"
              v-model="formData.enddate"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" class="pb-n5 mt-n8">
            <v-btn
              color="#6ACB9A"
              style="width: 100px; color: white"
              v-on:click="saveHandler()"
              >{{$t('button.save')}}</v-btn
            >
            <v-btn
              color="#1278D7"
              style="width: 100px; margin-left: 10px; color: white"
              v-on:click="processHandler()"
              >{{$t('button.import')}}</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ErrorDialogue from "../../../components/common/ErrorDialog";
import moment from "moment";
import Loading from "vue-loading-overlay";

export default {
  components: {
    "app-error": ErrorDialogue,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        requiredRouding: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('clockdata.importclockdata'),
      pageTitleValue: "",
      formData: {
        importfile: null,
        startdate: moment().format("YYYY-MM-DD"),
        enddate: moment().format("YYYY-MM-DD"),
        inindicator: null,
        outindicator: null,
        logicid: null,
        logiccode: null,
        userid: this.$store.getters.userId,
      },
      logiclist: [],
      logic: [],
      errMsg: "",
      isErr: false,
      editMode: false,
      loading: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.loading = true;
      this.$store.dispatch('post', {url: "/attnclockdata", payload: this.formData})
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          if (res.data.status == 201) {
            vm.loadLogicHandler();
            this.$dialog
              .alert("Default settings saved");
            // this.$dialog
            //   .alert(this.$t('piarabrpl'))
            //   .then((dialog) => {
            //     console.log(dialog);
            //   });
          } else {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          this.loading = false;
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
    processHandler() {
      const vm = this;

      if (this.formData.importfile == null) {
        this.$dialog.alert(this.$t('selectfileimport')).then((dialog) => {
        console.log(dialog);
        });
      } else if (this.formData.logicid == null){
          this.$dialog.alert(this.$t('selectimportfileformat')).then((dialog) => {
          console.log(dialog);
        });
      } else {

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      console.log(vm.formData);

      let data = new FormData();
      data.append("importfile", this.formData.importfile);
      data.append("inindicator", this.formData.inindicator);
      data.append("outindicator", this.formData.outindicator);
      data.append("startdate", this.formData.startdate);
      data.append("enddate", this.formData.enddate);
      data.append("logicid", this.formData.logicid);
      data.append("logiccode", this.formData.logiccode);
      data.append("userid", this.$store.getters.userId);
      data.append("headers", {
            "Content-Type": "multipart/form-data",
          });
      this.loading = true;
      this.$store.dispatch('post', {url: "/importclockdata", payload: data})
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          if (res.data.status == 201) {
            this.$router.push({
              name: "importclockdatalog",
              params: {
                staffcount: res.data.res.staffcount,
                processed: res.data.res.processed,
                uploaded: res.data.res.uploaded,
                skipped: res.data.res.skipped,
              },
            });
            // this.$dialog
            //   .alert(this.$t('piarabrpl'))
            //   .then((dialog) => {
            //     console.log(dialog);
            //   });
          } else {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          this.loading = false;
          vm.isErr = true;
          vm.errMsg = err;
        });
      }
    },
    loadLogicHandler() {
      const vm = this;
      this.$store.dispatch('get', {url: "/attnclockdata/all"})
        .then(function (res) {
          vm.logic = res.data.rec;
          vm.logiclist = [];
          for (let i = 0; i < res.data.rec.length; i++) {
              vm.logiclist.push({
              text: res.data.rec[i].logicname,
              value: res.data.rec[i].logicid,
            });
          }
          vm.ChangeLogic(vm.logiclist[0].value);
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },
    ChangeLogic(id) {
      let item = this.logic.find((item) => item.logicid === id);
      this.formData.logicid = item.logicid;
      this.formData.logiccode = item.logiccode;
      this.formData.inindicator = item.inindicator;
      this.formData.outindicator = item.outindicator;
    },
  },
  mounted() {
    this.loadLogicHandler();
  },
};
</script>
